<template>
  <v-app>
    <Error />
    <AppBar />

    <v-main>
      <v-container
        fluid
        class="page-wrapper bg-background"
      >
        <!-- <div class="container verticalLayout"> -->
        <!-- <div class="maxWidth"> -->
        <InfoBar />

        <router-view v-slot="{ Component }">
          <v-fade-transition hide-on-leave>
            <component :is="Component" />
          </v-fade-transition>
        </router-view>
        <!-- </div> -->
        <!-- </div> -->
      </v-container>
    </v-main>
  </v-app>
</template>

<script lang="ts" setup>
//
</script>
